import { Box, styled, Typography } from '@mui/material';
import { Column, Row } from 'further-ui/components/Layout';
import api from 'lib/trpcClient';

import PreviousResultsContainer from './PreviousResultsContainer';
import InvestorClassificationResult from '../InvestorClassificationDetails/InvestorClassificationResult';

const Container = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0, theme.spacingSizes.sm),
}));

const ExpiredAt = styled(Typography)({
  flexShrink: 0,
});

type Props = {
  vehicleId: string;
  vehicleApplicationId: string;
};

const PreviousInvestorClassifications: React.FC<Props> = ({
  vehicleId,
  vehicleApplicationId,
}) => {
  const [expiredClassificationResults] =
    api.investorClassification.listExpiredClassificationResults.useSuspenseQuery(
      {
        vehicleId,
        vehicleApplicationId,
      },
    );
  const [onboardingSettings] = api.vehicle.onboardingSettings.useSuspenseQuery({
    vehicleId,
  });

  if (!expiredClassificationResults.length) {
    return null;
  }

  return (
    <PreviousResultsContainer>
      {expiredClassificationResults.map((classificationResult) => (
        <Container key={classificationResult.id}>
          <Row fullWidth justify="space-between">
            <Column fullWidth spacing="md">
              <InvestorClassificationResult
                classificationResult={classificationResult}
                onboardingSettings={onboardingSettings}
              />
            </Column>
            <ExpiredAt variant="body2" align="right">
              Expired on {classificationResult.expiredAt?.toReadableWithTime()}
            </ExpiredAt>
          </Row>
        </Container>
      ))}
    </PreviousResultsContainer>
  );
};

export default PreviousInvestorClassifications;
